
<template>
  <v-layout wrap justify-center>
    <v-flex xs12 px-5 pb-5 align-self-center>
      <!-- <v-snackbar v-model="showsnackbar" color="green" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ snackmessage }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar> -->
      <v-layout wrap justify-start>
        <v-flex px-4 xs12 pt-3 v-if="imgList.length">
          <h2 style="poppins-bold">{{ type }}</h2>
        </v-flex>
        <v-flex
          px-8
          xs12
          sm6
          md4
          xl4
          v-for="(item, i) in imgList"
          :key="i"
          pa-3
        >
          <v-card tile>
            <v-layout wrap justify-center pb-2 @click="showUp(item)">
              <v-flex xs12>
                <v-img v-if="imgList.length" :src="item.path" height="200px">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color=" #FDAC53"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-img
                  v-else
                  src="../../assets/images/no-image.png"
                  height="200px"
                />
              </v-flex>

              <v-flex
                align-self-center
                text-center
                xs12
                :style="{ height: '0px' }"
                text-left
                pa-4
                py-8
              >
                <!-- <router-link
                  class="routerlink"
                  :to="'/seaturtles2/' + item._id"
                > -->
                <!-- <v-btn plain elevation="0"  class="text-none"> -->
                <span
                  style="
                    font-family: poppins-bold;
                    color: black;
                    font-size: 18px;
                    cursor: pointer;
                  "
                  >{{ item.title }}</span
                >
                <!-- </v-btn> -->

                <!-- <span class="caption">
                  {{ item.caption }}
                </span> -->
                <!-- </router-link> -->
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-dialog
          v-if="current"
          v-model="dialog"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card v-bind="current">
            <v-img :src="current.path">
              <!-- <v-layout wrap>
              <v-flex xs12 px-12 align-self-end text-right>
                <v-btn fixed color="red" @click="showOff">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>  -->
            </v-img>
          </v-card>
        </v-dialog>

        <v-flex xs12 px-12 py-12 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12 align-self-center text-center>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 25px;
                "
              >
                Glossary
              </span>
            </v-flex>

            <v-flex xs12 sm3 py-2 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Abdominal scutes
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                fourth pair of scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Anal scutes
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                sixt and last pair of scutes below femoral scutres near tail in
                posterior of plastron
              </span>
            </v-flex>

            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Axillary scutre
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                scutre on the anterior of the bridge
              </span>
            </v-flex>

            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Calipee
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                shell cartilage in softshell turtles running from the midsection
                to the posterior of the body
              </span>
            </v-flex>

            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Callosity
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a hardened area of skin,occassionally with sculptured bone
                exposed
              </span>
            </v-flex>

            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Carapace
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                dorsal shell of a turtle
              </span>
            </v-flex>

            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Caudal scutes
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                last two scutres in posterior of carapace above tail area
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Cloaca
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                common opening for excretion of waste products and for the sex
                organs
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Costal scutre
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                two sets of four scutres on either side of vertebral scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Digit
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                finger or toe
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Femoral scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                fifth pair of scutes below abdominal scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Gular scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                pair of anterior most scutes on plastron
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Gular scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                pair of anterior most scutes on plastron
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Humeral scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                second pair of scutes on plastron below gular scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Inguinal scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                scute on the posterior of the bridge
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Keel
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a narrow prominent ridge on top of the carapace running along
                the vertebral scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Marginal scutes
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                ring of two sets of 11 scutes running along edge of carapace,
                starting from nuchal scute and end ending at caudal scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Nuchal scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                top most scute on the anterior of the carapace directly behind
                the head
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Ocelli
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                dark circular markings on carapace; also 'eyes'
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Pectoral scutes
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                third pair of scutes on plastron below humeral scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Plastron
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                the ventral shell of a turtle
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Proboscis
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                elongated snout-like projection from teh fron of head
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a horny epidernal shell
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Seam
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a line of contact between two scutes
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Terrapin
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a type of turtle typically found in fresh or brackish estuarine
                waters; not recognized as a taxonomic unit
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Tortoise
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a type of turtle that is fully terrestrail and characterized by
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Tubercle
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                a know-like projection
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Turtle
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                an aquatic or semi-aquatic reptile characterized by a bony or
                cartilagineous shell that acts as shield and with webbed feet
                between individual digits
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Tympanum
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                air filled hearing structure behind the eye or 'upper cheek' of
                animal; plastron plain without marking
              </span>
            </v-flex>
            <v-flex xs12 sm3 py-2>
              <span
                style="
                  color: black;
                  font-family: poppins-semibold;
                  font-size: 21px;
                "
              >
                Vertebral scute
              </span>
            </v-flex>
            <v-flex xs12 sm9 align-self-center text-left>
              <span
                style="
                  color: black;
                  font-family: poppins-light;
                  font-size: 20px;
                "
              >
                column of five scutes running down the middle of the carapace
                from the head towards the tail
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
// import axios from "axios";
export default {
  props: ["type"],
  data() {
    return {
      showsnackbar: [],
      snackmessage: [],
      loader: null,
      dialog: false,
      // dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      imgList: [
        {
          path: require("../../assets/images/hardshell_dorsal_labelled.jpg"),
          title: "Hard Shell Dorsal",
        },
        {
          path: require("./../../assets/images/hardshell_lateral_labelled.jpg"),
          title: "Hard Shell Lateral",
        },
        {
          path: require("../../assets/images/hardshell_ventral_labelled.jpg"),
          title: "Hard Shell Ventral",
        },
        {
          path: require("./../../assets/images/limb_types_labelled.jpg"),
          title: "Limb Differentiation",
        },
        {
          path: require("./../../assets/images/softshell_dorsal_labelled.jpg"),
          title: "Soft Shell Dorsal",
        },
        {
          path: require("./../../assets/images/softshell_ventral_labelled.jpg"),
          title: "Soft Shell Ventral",
        },
      ],
      current: [],
    };
  },
  methods: {
    showUp(eve) {
      this.current = eve;
      this.dialog = true;
    },
    showOff() {
      this.current = [];
      this.dialog = false;
    },
  },
};
</script>
<style>
.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>